module.exports = __webpack_public_path__ + "media/home/SeeUsInMotion-x1-0a7fe625.png";